module.exports = __webpack_public_path__ + "static/media/check-gray.6b4a8759.svg";